module.exports = __webpack_public_path__ + "images/tour/cards.34a432635a7d84c48d60.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/cards.svg
// module id = S7TE
// module chunks = 12